// Формат даты со временем один на весь новый код; библиотеки дат в features/ пока нет,
// а moment в проекте — легаси-точка (и именно на нём старая страница печатала минуты как месяц).
export const formatDateTime = (value: number | Date): string => {
    const date = value instanceof Date ? value : new Date(value);

    const pad = (part: number) => String(part).padStart(2, "0");

    return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(
        date.getHours()
    )}:${pad(date.getMinutes())}`;
};

// Без времени — там, где важен календарный день, а не момент (срок действия промокода).
export const formatDate = (value: number | Date): string => {
    const date = value instanceof Date ? value : new Date(value);

    const pad = (part: number) => String(part).padStart(2, "0");

    return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
};
